import type { Slicer } from '@swf/core/store';

import type { SportsPromotionState } from './types';

export const selectors = (slice: Slicer<SportsPromotionState>) => ({
  promotion: () => slice((state) => state.data),
  hasErrored: () => slice((state) => state.hasErrored),
  hasPreloaded: () => slice((state) => state.hasPreloaded)
});
